import { printManager } from '@provider/print';
import { PrinterIcon } from '@ui/kit/icons';
import { asyncTimeout } from '@utils/common';
import { UniversalContextMenuButton } from '../molecule.contextmenu.js';
import { applyCustomCssStylesheet, hideIrrelevantNodes, resetIrrelevantNodes } from '../util.export.js';
import { jsx } from 'react/jsx-runtime';

function LegacyPrintButton(props) {
  return /*#__PURE__*/jsx(UniversalContextMenuButton, {
    as: "button",
    layout: props.layout,
    label: "Print",
    onClick: () => {
      props.onClick?.();
      print(props.targetRef, props.printCss, {
        onBeforePrint: props.onBeforePrint,
        onAfterPrint: props.onAfterPrint
      });
    },
    icon: /*#__PURE__*/jsx(PrinterIcon, {
      height: 20
    })
  });
}
async function print(targetRef, css, callbacks) {
  await callbacks.onBeforePrint?.();
  const target = targetRef.current?.querySelector("[data-print-target]") ?? targetRef.current;
  if (!target) {
    console.warn("print(): Unable to resolve target");
    await callbacks.onAfterPrint?.();
    return;
  }
  const customPrintStylesheet = applyCustomCssStylesheet(css);
  hideIrrelevantNodes(target);
  await asyncTimeout(10);

  // And then ensure to reset their visiblity once printing has been
  // completed.
  const afterPrint = () => {
    // debounce clean up slightly, so that Android Chrome prints with the
    // correct styles
    //
    // @see ADO #111443
    setTimeout(async () => {
      resetIrrelevantNodes(target);

      // remove custom print stylesheet so it doesn't leak into the abstraction
      customPrintStylesheet?.remove();
      await callbacks.onAfterPrint?.();
    }, 1000);
  };
  window.addEventListener("afterprint", afterPrint, {
    once: true
  });
  printManager.triggerPrintDialog({
    incompatibleContent: true
  });
}

export { LegacyPrintButton };
//# sourceMappingURL=button.js.map
